import React from 'react';
import Svg from 'react-svg-y';
import Dialog from 'react-dialog-y';
import ScrollBox from 'react-scroll-y';
import {
    formContDefault,
    formContBox,
    defaultError,
    boxError,

    setLocationClass,
} from '../publicField';
// import TipBox from '../../../tipbox/tipBox';

//select 获取值
let getValue = (_this) => {
    let formDataValue = _this.props.formData[_this.props.dataType || "default"];
    let inputData = formDataValue && formDataValue[_this.props.inputName];
    return inputData && inputData.text ? inputData.text : "";
};

//select 的校验
const verifyFn = (_this) => {
    const required = _this.props.required || false,
        initFocusState = _this.state.initFocusState,
        value = getValue(_this);

    let errorText = _this.props.errorText || "该值不能为空!";
    let errorState = false;

    let subVerifyRes = _this.props.subVerifyRes && _this.props.subVerifyRes[_this.props.dataType || "default"];

    //如果是必填
    if (required && (subVerifyRes == "fail" || initFocusState == 1)) {
        if (value.trim()) {
            errorState = false;
        } else {
            errorState = true;
        }
    }
    return {errorState, errorText};
};

/**
 * 下拉内容展示区
 * @returns {XML}
 */
const selectCont = (_this, styles, value, width) => {
    return <ScrollBox shouldUpdate={_this.state.shouldUpdate}
                      initScroll={_this.initScroll}
        //scrollWrapColor="red"
        //scrollBarColor="green"
                      botFixed={false}
        //rigFixed={false}
                      width={width}
                      maxHeight="20rem"
                      bottomScroll="N"
    >
        {_this.props.dataSource.map((item, index) => {
            return <div key={index}
                        style={_this.state.moveSelect == item.text ? styles.selectItemMove :
                            value == item.text ? styles.selectItemCheck :
                                styles.selectItem}
                        onMouseMove={_this.moveSelect.bind(this, item)}
                        onMouseLeave={_this.leaveSelect.bind(this, item)}
                        onClick={_this.handleSelect.bind(this, item)}>
                {item.text}
            </div>
        })}
    </ScrollBox>
};

/**
 * selectType 为 select 的类型
 */
const defaultSelect = (_this, styles, value) => {
    let width = (parseFloat(styles.formBox.width) - 0.2) + "rem";
    return [
        <div key="1" onClick={_this.closeSelect} style={styles.selectdialogMask}></div>,
        <div key="2" style={styles[setLocationClass(_this)]}>
            {selectCont(_this, styles, value, _this.props.selectWidth || width)}
        </div>
    ]
};
/**
 * selectType 为 dialog 的类型
 */
const defaultDialog = (_this, styles, value) => {
    let width = parseFloat(styles.formBox.width);
    let widthScroll = (width < 20 ? 20 : width) + "rem";
    let widthDialog = ((width < 20 ? 20 : width) + 4) + "rem";
    let dialogSty = {
        maxWidth: widthDialog,
        width: widthDialog,
        maxHeight: "26rem",
        height: "26rem",
    };
    return [
        <Dialog key="1" open={_this.state.showSelect}
                onRequestClose={_this.closeSelect}
                contentStyle={dialogSty}
                bodyStyle={dialogSty}>
            <div>
                <div style={styles.dialogTit}>请选择{_this.props.formText}</div>
                {selectCont(_this, styles, value, widthScroll)}
            </div>
        </Dialog>
    ]
};

/**
 * input value dom
 */
const formValueDom = (_this, styles, value, theme)=> {
    return [
        !value ? (
            <span key={1} style={styles.inputHintText}>{_this.props.hintText}</span>
        ) : (null),
        _this.props.disabled ?
            <div key={2} style={styles.selectBoxDis} title={value}>{value}</div> :
            <div key={3}
                 style={_this.state.focusState ? styles.selectBoxFocus : styles.selectBox}
                 title={value}
                 onClick={_this.showSelectFn}
            >
                {/*<TipBox title={value} showType='move' tipBoxWidth='300px' tipBoxHeight='80px'>*/}
                <div style={styles.inputText}>{value} </div>
                {/*</TipBox>*/}
                <div style={styles.inputSvg}>
                    <Svg type="Bottom" width="1rem" height="1rem" fill={theme.publicForm.inputSvgFill}/>
                </div>
            </div>,
    ]
};

/**
 * formType 是 default 类型
 * @param verifyFlag 校验返回值
 */
const defaultDom = (_this, styles, verifyFlag, _theme) => {
    if (!_this.props.inputName) {
        return <div>inputName为必要参数</div>
    }
    let value = getValue(_this);
    let selectType = _this.props.selectType || "select";
    return (
        <div ref='formBox' style={styles.formBox}>
            {/*表单框架*/}
            {formContDefault(_this, styles, verifyFlag, getValue(_this), formValueDom, _theme)}
            {/*报错提示*/}
            {defaultError(verifyFlag, styles)}

            {_this.state.showSelect && _this.props.dataSource && _this.props.dataSource.length > 0 && selectType == "select" &&
            defaultSelect(_this, styles, value)
            }

            {_this.state.showSelect && _this.props.dataSource && _this.props.dataSource.length > 0 && selectType == "dialog" &&
            defaultDialog(_this, styles, value)
            }

        </div>
    )
};

/**
 * formType 是 box 类型
 * @param verifyFlag 校验返回值
 */
const boxDom = (_this, styles, verifyFlag, _theme) => {
    if (!_this.props.inputName) {
        return <div>inputName为必要参数</div>
    }
    let value = getValue(_this);
    let selectType = _this.props.selectType || "select";
    return (
        <div ref='formBox' style={styles.formBox}>
            {/*表单框架*/}
            {formContBox(_this, styles, verifyFlag, getValue(_this), formValueDom, _theme)}
            {/*报错提示*/}
            {boxError(verifyFlag, styles)}

            {_this.state.showSelect && _this.props.dataSource && _this.props.dataSource.length > 0 && selectType == "select" &&
            defaultSelect(_this, styles, value)
            }

            {_this.state.showSelect && _this.props.dataSource && _this.props.dataSource.length > 0 && selectType == "dialog" &&
            defaultDialog(_this, styles, value)
            }

        </div>
    )
};

const formTypeDom = {
    defaultDom,
    boxDom
};

export {
    formTypeDom,
    verifyFn,
}

